<pagination [listId]="listId"></pagination>
<div class="items">
  <search-sections-item [section]="section" *ngFor="let section of items"></search-sections-item>
</div>
<pagination [listId]="listId"></pagination>
